import { CreateElement, CreateElementParams, Rect, Size } from ".././MyHelpers";

import { nanoid } from "nanoid";

export class MyCanvasContext
{
    public _context: CanvasRenderingContext2D;
    public depth: number = 0;
    protected frozen: boolean = false;

    public constructor(_contenxt: CanvasRenderingContext2D)
    {
        this._context = _contenxt;
    }

    public Freeze(): void
    {
        this.frozen = true;
    }

    public save()
    {
        this.depth++;
        if (this.depth > 10)
        {
            console.error(`canvas.context.save() overflow: ${this.depth}`);
        }

        this._context.save();
    }

    public restore()
    {
        this.depth--;
        if (this.depth < 0)
        {
            console.error(`canvas.context.save() under 0: ${this.depth}`);
        }

        this._context.restore();
        this._context.resetTransform();
    }

    // CanvasText
    public fillText(text: string, x: number, y: number, maxWidth?: number): void {
        if (this.frozen) throw "Canvas was frozen"; 
        return this._context.fillText(text, x, y, maxWidth); 
    }
    public measureText(text: string): TextMetrics { 
        if (this.frozen) throw "Canvas was frozen";
        return this._context.measureText(text); 
    }
    public strokeText(text: string, x: number, y: number, maxWidth?: number): void { 
        if (this.frozen) throw "Canvas was frozen";
        return this._context.strokeText(text, x, y, maxWidth); 
    }

    // CanvasTransform
    public translate(x: number, y: number): void { return this._context.translate(x, y); }
    public scale(x: number, y: number): void { return this._context.scale(x, y); }
    public rotate(angle: number): void { return this._context.rotate(angle); }
    public resetTransform(): void { return this._context.resetTransform(); }

    // CanvasTextDrawingStyles
    public set font(value: string) { this._context.font = value; }
    public set textAlign(value: CanvasTextAlign) { this._context.textAlign = value; }
    public set textBaseline(value: CanvasTextBaseline) { this._context.textBaseline = value; }

    // CanvasRect
    public clearRect(x: number, y: number, w: number, h: number): void { 
        if (this.frozen) throw "Canvas was frozen";
        return this._context.clearRect(x, y, w, h);
    }

    // CanvasDrawImage
    // public drawImage(image: CanvasImageSource, dx: number, dy: number): void { return this._context.drawImage(image, dx, dy); }
    // public drawImage(image: CanvasImageSource, dx: number, dy: number, dw: number, dh: number): void { return this._context.drawImage(image, dx, dy, dw, dh); }
    public drawImage(image: CanvasImageSource, sx: number, sy: number, sw?: number, sh?: number, dx?: number, dy?: number, dw?: number, dh?: number): void { 
        if (this.frozen) throw "Canvas was frozen";
        return this._context.drawImage(image, sx, sy, sw, sh, dx, dy, dw, dh); 
    }

    // CanvasShadowStyles
    public set shadowBlur(value: number) { this._context.shadowBlur = value; }
    public set shadowColor(value: string) { this._context.shadowColor = value; }
    public set shadowOffsetX(value: number) { this._context.shadowOffsetX = value; }
    public set shadowOffsetY(value: number) { this._context.shadowOffsetY = value; }

    // CanvasPathDrawingStyles
    public set lineJoin(value: CanvasLineJoin) { this._context.lineJoin = value; }
    public set lineWidth(value: number) { this._context.lineWidth = value; }
    public get lineWidth(): number { return this._context.lineWidth }
    public set miterLimit(value: number) { this._context.miterLimit = value; }


    // CanvasFillStrokeStyles
    public set fillStyle(value: string | CanvasGradient | CanvasPattern) { this._context.fillStyle = value; }
    public set strokeStyle(value: string | CanvasGradient | CanvasPattern) { this._context.strokeStyle = value; }
    public createLinearGradient(x0: number, y0: number, x1: number, y1: number): CanvasGradient { return this._context.createLinearGradient(x0, y0, x1, y1); }
    
    // CanvasFilters
    public set filter(value: string) { this._context.filter = value; }

    // CanvasDrawPath
    public beginPath(): void { return this._context.beginPath();}
    public clip(fillRule?: CanvasFillRule): void { return this._context.clip(fillRule);}
    //public clip(path: Path2D, fillRule?: CanvasFillRule): void { return this._context.clip(path, fillRule?);}
    public fill(fillRule?: CanvasFillRule): void { return this._context.fill(fillRule);}
    //public fill(path: Path2D, fillRule?: CanvasFillRule): void { return this._context.fill(path: Path2D, fillRule?: CanvasFillRule);}
    // public isPointInPath(x: number, y: number, fillRule?: CanvasFillRule): boolean { return this._context.isPointInPath(x: number, y: number, fillRule?: CanvasFillRule);}
    // public isPointInPath(path: Path2D, x: number, y: number, fillRule?: CanvasFillRule): boolean { return this._context.isPointInPath(path: Path2D, x: number, y: number, fillRule?: CanvasFillRule);}
    // public isPointInStroke(x: number, y: number): boolean { return this._context.isPointInStroke(x: number, y: number);}
    // public isPointInStroke(path: Path2D, x: number, y: number): boolean { return this._context.isPointInStroke(path: Path2D, x: number, y: number);}
    //public stroke(): void { return this._context.stroke();}
    public stroke(path?: Path2D): void { return this._context.stroke(path);}
    public fillRect(x: number, y: number, width: number, height: number) { return this._context.fillRect(x, y, width, height); }

    

    // CanvasPath
    public arc(x: number, y: number, radius: number, startAngle: number, endAngle: number, anticlockwise?: boolean): void { return this._context.arc(x, y, radius, startAngle, endAngle, anticlockwise)}
    public arcTo(x1: number, y1: number, x2: number, y2: number, radius: number): void { return this._context.arcTo(x1, y1, x2, y2, radius)}
    public bezierCurveTo(cp1x: number, cp1y: number, cp2x: number, cp2y: number, x: number, y: number): void { return this._context.bezierCurveTo(cp1x, cp1y, cp2x, cp2y, x, y)}
    public closePath(): void { return this._context.closePath()}
    public ellipse(x: number, y: number, radiusX: number, radiusY: number, rotation: number, startAngle: number, endAngle: number, anticlockwise?: boolean): void { return this._context.ellipse(x, y, radiusX, radiusY, rotation, startAngle, endAngle, anticlockwise)}
    public lineTo(x: number, y: number): void { return this._context.lineTo(x, y)}
    public moveTo(x: number, y: number): void { return this._context.moveTo(x, y)}
    public quadraticCurveTo(cpx: number, cpy: number, x: number, y: number): void { return this._context.quadraticCurveTo(cpx, cpy, x, y)}
    public rect(x: number, y: number, w: number, h: number): void { return this._context.rect(x, y, w, h)}

    // ImageBitmapRenderingContext
    public get canvas(): HTMLCanvasElement { return this._context.canvas }

    public getImageData(sx: number, sy: number, sw: number, sh: number): ImageData { return this._context.getImageData(sx, sy, sw, sh); }
    public putImageData(imagedata: ImageData, dx: number, dy: number): void { return this._context.putImageData(imagedata, dx, dy); };
}

export interface MyCanvasParams
{
    canvasSize: Size;
    elemParams?: CreateElementParams<"canvas">;
}


const canvases = [];
export function crashcanvas()
{
    console.log(`Crashing ${canvases.length} canvases...`);

    let newSize: Size = new Size();
    for (let c of canvases)
    {
        let canvas: MyCanvas = c as MyCanvas;

        let originalSize = canvas.size;
        newSize.Width = originalSize.Width +1;
        newSize.Height = originalSize.Height +1;
        canvas.SetSize(newSize);
        canvas.SetSize(originalSize);
    }
}

globalThis.crashcanvas = crashcanvas;
globalThis.canvases = canvases;

let   canvasCheckLastIndex = 0;
const canvasCheckBatchSize = 50;

window.addEventListener("load", CheckCanvases);

function CheckCanvases()
{
    console.log(`Checking canvases, total: ${canvases.length}, last: ${canvasCheckLastIndex}, batch: ${canvasCheckBatchSize}`);

    let ii = 0;
    for (let i = 0; i < 50; i++)
    {
        ii = canvasCheckLastIndex + i;
        if (ii > canvases.length) ii -= canvases.length;

        try
        {
            canvases[ii].CheckHealth();
        }
        catch {}
    }

    canvasCheckLastIndex = ii;
}

export type OnContextLostHandler = () => void;

export class MyCanvas
{
	public size: Size;
	public rect: Rect;
	public view: HTMLCanvasElement;
	public context: MyCanvasContext;

    public static readonly canvases: MyCanvas[] = [];

	public constructor(canvasSize: Size, /*onContextLost: OnContextLostHandler, */elemParams?: CreateElementParams<"canvas">) {

		this.size = canvasSize;
		this.rect = new Rect(0, 0, this.size.Width, this.size.Height);

		if (elemParams && elemParams.style && (elemParams.style.width  || elemParams.style.height))
		{
			//throw "Size should be only set via canvas size, and not via style";
		}

        if (!elemParams)
        {
            elemParams = {};
        }

        if (!elemParams.classes)
        {
            elemParams.classes = [];
        }

        elemParams.classes.push("mycanvas-" + nanoid());

		this.view = CreateElement("canvas", elemParams);
		this.view.width = this.size.Width;
		this.view.height = this.size.Height;

		this.context = new MyCanvasContext(this.view.getContext("2d"));

        canvases.push(this);

        this.RestoreContext();
	}

	// change size of canvas
	public SetSize(size: Size): void {
		this.size = size;
		this.view.width = size.Width;
		this.view.height = size.Height;

		this.rect = new Rect(0, 0, this.size.Width, this.size.Height);
	}

	public Clear(): void {
		this.context.clearRect(0, 0, this.size.Width, this.size.Height);
	}

	public DrawImage(image: CanvasImageSource, sourceRect: Rect, destRect: Rect): void {
		this.context.drawImage(
			image,

			sourceRect.x,
			sourceRect.y,
			sourceRect.width,
			sourceRect.height,

			destRect.x,
			destRect.y,
			destRect.width,
			destRect.height
		);
    }

    public Freeze(): void
    {
        this.context.Freeze();
    }
    
    public Canvas(): HTMLCanvasElement 
    {
        return this.view;
    }

    public View(): HTMLElement 
    {
		return this.view;
	}

    public Destroy(): void
    {
        let index = globalThis.canvases.findIndex(c => c == this);
        if (index != null)
        {
            delete globalThis.canvases[index];
        }
    }

    public RestoreContext(): void
    {
        this.context.lineWidth = 2;
    }

    public WasContextLost(): boolean
    {
        return this.context.lineWidth != 2;
    }

    public CheckContextLost(): void
    {
        if (!this.WasContextLost())
        {
            console.log("Context lost", this);
            this.onContextLost?.();
        }
    }

    public onContextLost: OnContextLostHandler = null;
}

// override createElement

// const originalCreateElement = document.createElement;
// const newCreateElement = function<K extends keyof HTMLElementTagNameMap>(tagName: K, options?: ElementCreationOptions): HTMLElementTagNameMap[K]
// {
//     if (tagName == "canvas")
//     {
//         throw "DONT CREATE CANVAS MANUALLY! Use MyCanvas class!";
//     }

//     originalCreateElement.apply(document, [tagName, options]);
// }

// newCreateElement.bind(document);
// document.createElement = newCreateElement;